;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.quote.show')
    .controller('MarkQuoteController', MarkQuoteController)

  MarkQuoteController.$inject = ['$uibModalInstance', 'DatePickerService', 'status']

  function MarkQuoteController ($uibModalInstance, DatePickerService, status) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Attributes
        status: status,
        signDate: new Date(),

        // Methods
        cancel: cancel,
        accept: accept,
        refuse: refuse,
        setSignDate: setSignDate,
        resetSignDate: resetSignDate,
        getStateLabel: getStateLabel,
        getActionLabel: getActionLabel
      })
    }

    function resetSignDate () {
      self.signDate = null
    }

    function setSignDate () {
      DatePickerService.getRange(self.signDate).then(function (date) {
        self.signDate = new Date(date)
      })
    }

    function getStateLabel () {
      return status === 'refused' ? 'refusé' : 'signé'
    }

    function getActionLabel () {
      return status === 'refused' ? 'Refuser' : 'Signer'
    }

    function accept () {
      $uibModalInstance.close(self.signDate)
    }

    function refuse () {
      $uibModalInstance.close(false)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }
})(window.angular, window._)
